<template>
  <div class="w-full h-full">
    <div v-if="loadArticle == 'non' && articles.data.length == 0" class="w-full h-full flex items-center justify-center">
      <div>
        <img class="w-[50%] mx-auto" src="/icons/empty.png" alt="" srcset="">
        <p class="text-center text-[#6B6B6B]">{{ $t('aucunarticletrouve') }}</p>
      </div>
    </div>
    <div v-if="loadArticle == 'non' && articles.data.length > 0"  @scroll="loadInfinite" class="w-full h-full overflow-y-auto  p-2 scrollbar-hide justify-center relative ">
      <div class="grid gap-2 grid-cols-[repeat(auto-fill,minmax(240px,240px))] md:grid-cols-[repeat(auto-fill,minmax(240px,1fr))] justify-center" >
        <div v-for="article in articles.data" :key="article.id" class="md:h-[360px] h-[380px] rounded-md overflow-hidden shadow shadow-[#ff9900] relative">
          <div :class="monProfil.status == 'block' ? 'opacity-50':'opacity-100'" >
            <div :class="articlePanier.filter(item => item.id == article?.id)[0]?.id ==  article?.id ? 'bg-green-500':' hover:bg-[#f4f4f4] bg-[#EBEBEB]'" class="absolute bottom-1 right-2 w-12 h-[12%]  shadow-xl rounded-md flex items-center overflow-hidden">
              <div v-if="articlePanier.filter(item => item.id == article?.id)[0]?.id !=  article?.id" class="w-full h-full flex items-center">
                <div v-if="loadAddPanier == 'non' && article.id == form.id" class="w-full h-full flex items-center backdrop-blur-sm absolute z-20">
                    <div class=" w-5 h-5 mx-auto relative flex items-center">
                      <svg aria-hidden="true" class="inline absolute w-full h-full text-gray-200 animate-spin dark:text-white fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                      </svg>
                    </div>
                </div>
                <button :disabled="monProfil.status == 'block'? true:false" @click="addPanier(article)" class="h-full w-full">
                  <img class="h-5 mx-auto" src="/icons/add_shopping.png" alt="" srcset="" loading="lazy">
                </button>
              </div>
              <div v-if="articlePanier.filter(item => item.id == article?.id)[0]?.id ==  article?.id" class="w-full h-full flex items-center">
                <img class="h-5 mx-auto" src="/icons/checked.png" alt="" srcset="" loading="lazy">
              </div>
            </div>
          </div>
          <router-link :to="{name:'details', query:{id:encryptId(article.id), prix: article.prix, nom: article.nom, marque:article.marque, ville:article.ville, image:encryptId(JSON.parse(article.image)['image0'])} }" class="w-full h-full">
            <div class="w-full h-[45%] relative">
              <swiper
                :slidesPerView="'auto'"
                :modules="modules"
                class="mySwiper bg-black" 
                :loop="true"
                :autoplay="true"
              >
                <swiper-slide v-for="(image) in JSON.parse(article.image)" :key="image.id" class="w-full h-full swiper-slide-image-article">
                  <img @load="imgLoad(image)" class="w-full h-full object-cover object-center  bg-center bg-contain bg-no-repeat" src="/logo/loadlogo.png"  srcset="" loading="lazy">
                </swiper-slide> 
              </swiper>
            </div>
            <div class="w-full h-[55%] px-2">
              <div class=" w-full h-[56%]">
                <p class="text-[1rem] font-semibold">{{ article.marque ? (article.marque) : ''  }} {{ article.nom }}</p>
                <!-- ecran sm -->
                <p v-if="article.description.length > 190" class="mt-1 text-xs text-gray-700 text-justify hyphens-auto"><span class="text-md font-bold">Description :</span> {{ article.description.substring(0,190) + '...' }}</p>
                <p v-if="article.description.length <= 190" class="mt-1 text-xs text-gray-700 text-justify hyphens-auto"><span class="text-md font-bold">Description :</span> {{ article.description }}</p>
              </div>
              <div class="w-full flex space-x-2 mt-[0.6rem] h-[10%]">
                <div class="h-full flex items-center">
                  <div class="flex space-x-1">
                    <button>
                      <svg :class="Math.round(user.etoile/user.avis) >= 1 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                        <g id="surface1">
                        <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                        </g>
                      </svg>
                    </button>
                    <button>
                      <svg :class="Math.round(user.etoile/user.avis) >= 2 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                        <g id="surface1">
                        <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                        </g>
                      </svg>
                    </button>
                    <button>
                      <svg :class="Math.round(user.etoile/user.avis) >= 3 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                        <g id="surface1">
                        <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                        </g>
                      </svg>
                    </button>
                    <button>
                      <svg :class="Math.round(user.etoile/user.avis) >= 4 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                        <g id="surface1">
                        <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                        </g>
                      </svg>
                    </button>
                    <button>
                      <svg :class="Math.round(user.etoile/user.avis) >= 5 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                        <g id="surface1">
                        <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                        </g>
                      </svg>
                    </button> 
                  </div>
                </div>
                <div class="flex h-full items-center">
                  <p class=" text-[0.7rem]">{{ user.avis }} {{ $t('avis') }}</p>
                </div>
              </div>
              <div class="w-full justify-between flex py-2 h-[34%]">
                <div class="flex space-x-2 h-full items-center">
                  <div class="w-[1.5rem] h-[1.5rem] rounded-full">
                    <img class="h-full" src="/icons/dollar.png" loading="lazy"/>
                  </div>
                  <div>
                    <div class="flex space-x-1">
                      <div class="h-auto flex items-center">
                        <p class="text-[#FF9900]"> <span class="font-semibold">{{ transformAmount(article.prix) }}</span></p>
                      </div>
                      <div class="h-auto flex items-center">
                        <svg class="h-6 fill-[#FF9900]" version="1.0" xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 433.000000 577.000000"
                          preserveAspectRatio="xMidYMid meet">

                              <g transform="translate(0.000000,577.000000) scale(0.100000,-0.100000)"
                              stroke="none">
                              <path d="M2248 5551 c-352 -49 -603 -368 -568 -719 16 -151 64 -290 185 -532
                              36 -71 65 -132 65 -135 0 -3 -13 -5 -28 -5 -69 0 -238 39 -531 121 -373 106
                              -480 129 -593 129 -105 0 -124 -11 -114 -65 11 -58 41 -80 124 -93 256 -38
                              496 -294 625 -668 79 -226 108 -444 108 -794 0 -598 -66 -944 -216 -1133 -59
                              -74 -96 -97 -158 -97 -81 0 -150 45 -177 114 -23 62 20 126 85 126 36 0 82 38
                              91 77 4 13 4 52 2 87 -9 145 -123 217 -341 216 -132 -1 -213 -43 -277 -142
                              -54 -83 -67 -156 -47 -259 45 -221 189 -377 393 -425 53 -12 101 -15 204 -11
                              156 5 251 30 358 94 58 34 156 125 178 165 8 15 39 13 409 -28 220 -25 401
                              -46 402 -48 6 -5 -28 -251 -48 -350 -44 -221 -106 -361 -199 -448 -62 -58
                              -128 -82 -230 -82 -167 -2 -264 88 -230 213 17 63 61 106 141 138 82 33 146
                              83 165 130 22 51 17 131 -9 178 -46 81 -202 128 -351 105 -136 -21 -248 -95
                              -329 -218 -105 -159 -148 -374 -102 -507 57 -165 214 -317 408 -395 138 -55
                              195 -65 387 -64 161 1 182 3 265 28 223 68 374 196 471 401 82 174 114 353
                              114 657 l0 196 63 7 c208 22 350 61 502 138 83 43 115 66 191 142 98 97 144
                              172 184 300 31 97 39 330 16 462 -20 115 -63 236 -118 327 -54 92 -174 211
                              -264 264 -103 60 -110 91 -35 141 250 161 192 565 -108 759 -70 46 -183 86
                              -281 101 -36 5 -162 13 -280 16 -118 3 -232 9 -254 13 l-38 7 -78 225 c-43
                              124 -81 234 -86 245 -5 13 9 5 40 -23 75 -69 124 -87 236 -87 87 0 100 3 163
                              33 200 98 307 324 252 532 -41 153 -166 306 -306 373 -124 60 -295 87 -431 68z
                              m-127 -1758 c75 -167 166 -410 156 -419 -3 -3 -57 -2 -120 2 l-115 7 -12 45
                              c-31 124 -110 284 -186 379 -19 23 -34 44 -34 47 0 3 63 6 140 6 l141 0 30
                              -67z m665 48 c60 -27 114 -80 140 -136 68 -144 -19 -271 -217 -318 -25 -6 -27
                              -4 -39 51 -12 53 -93 364 -106 405 -5 15 4 17 88 17 69 0 104 -5 134 -19z
                              m279 -840 c73 -33 127 -112 159 -232 68 -264 -18 -558 -223 -759 -64 -63 -116
                              -99 -126 -88 -3 3 -10 76 -15 164 -18 290 -46 543 -97 897 l-6 37 134 0 c108
                              0 142 -4 174 -19z m-676 -53 c43 -218 61 -463 61 -814 l0 -284 -350 0 c-192 0
                              -350 3 -350 7 0 4 20 45 44 92 83 161 170 405 230 641 30 121 32 136 17 141
                              -14 6 -14 8 2 14 14 6 17 20 17 71 0 48 3 64 14 64 9 0 16 18 20 54 7 54 8 55
                              44 59 20 2 83 4 139 5 l102 2 10 -52z m-309 -28 c0 -5 -4 -10 -10 -10 -5 0
                              -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
                              </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div v-if="fin == false && scrollExec" class="w-full flex items-center">
        <div class="chaotic-orbit mx-auto"></div>
      </div>
      <div class="w-full flex mt-1 text-gray-500" v-if="fin==true && articles.data.length > 0" >
        <p class="mx-auto" v-if="langue == 'fr'">Plus aucun éléments !</p>
        <p class="mx-auto" v-if="langue == 'en'">No more elements !</p>
      </div>
    </div>  
    <div v-if="loadArticle == 'oui'" class="w-full h-full grid gap-2 grid-cols-[repeat(auto-fill,minmax(240px,240px))] md:grid-cols-[repeat(auto-fill,minmax(240px,1fr))] justify-center overflow-y-auto  p-2 scrollbar-hide relative ">
      <div v-for="article in 20" :key="article.id" class="md:h-[360px] h-[380px] rounded-md overflow-hidden shadow shadow-[#ff9900] relative">
        <div class="w-full h-full">
          <div class="w-full h-[45%] bg-gray-500 animate-pulse relative"></div>
          <div class="w-full h-[55%] px-2">
            <div class="w-full h-[15%]">
              <div  class=" w-full h-1 bg-gray-500 mt-1 rounded-full animate-pulse"></div>
              <div class="w-full flex mt-1  items-center">
                <div class="w-[0.9rem] h-[0.9rem] p-[0.2rem] rounded-full flex bg-gray-500 animate-pulse"></div>
                <div class="ml-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              </div>
            </div>
            <div class=" w-full h-[41%]">
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="mt-1 h-[0.1rem] w-full bg-gray-500 animate-pulse"></div>
              <div class="w-1/2 mt-1 h-[0.1rem]  bg-gray-500 animate-pulse"></div>
            </div>
            <div class="w-full flex space-x-2 mt-[0.6rem] h-[5%]">
              <div class="h-full flex items-center">
                <div class="flex space-x-1">
                  <button>
                    <svg class="w-4 h-4 fill-gray-500 animate-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                      <g id="surface1">
                      <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                      </g>
                    </svg>
                  </button>
                  <button>
                    <svg class="w-4 h-4 fill-gray-500 animate-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                      <g id="surface1">
                      <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                      </g>
                    </svg>
                  </button>
                  <button>
                    <svg  class="w-4 h-4 fill-gray-500 animate-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                      <g id="surface1">
                      <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                      </g>
                    </svg>
                  </button>
                  <button>
                    <svg class="w-4 h-4 fill-gray-500 animate-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                      <g id="surface1">
                      <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                      </g>
                    </svg>
                  </button>
                  <button>
                    <svg  class="w-4 h-4 fill-gray-500 animate-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                      <g id="surface1">
                      <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                      </g>
                    </svg>
                  </button> 
                </div>
              </div>
              <div class="flex h-full items-center">
                <p class="w-6 h-[0.7rem] bg-gray-500 animate-pulse"></p>
              </div>
            </div>
            <div class="w-full justify-between flex py-2 h-[39%] items-center">
              <div class="flex space-x-2 h-full items-center">
                <div class="w-[1.5rem] h-[1.5rem] rounded-full bg-gray-500 animate-pulse"></div>
                <div>
                  <p class="w-6 h-[1.2rem] bg-gray-500 animate-pulse"></p>
                </div>
              </div>
              <div class="w-12 h-9 bg-gray-500 animate-pulse rounded-md"></div>
            </div>
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
  // Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import { Autoplay, FreeMode } from 'swiper';
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, FreeMode],
    };
  },
  data(){
    return{
      user:'',
      monProfil: {},
      page:1,
      articles:[],
      loadArticle:'',
      fin:false,
      articlePanier:[],
      loadAddPanier: '',
      scrollExec:false,
      form:{
        id:''
      },
      langue:''
    }
  },
  mounted(){
    this.monProfil = this.$store.state.dataAccueil[0]
    this.user = this.$store.state.viewProfil
    if(this.$store.state.dataAccueil[3].length > 0){
      this.articlePanier = this.$store.state.dataAccueil[3]
    }

    this.langue = localStorage.getItem('langue');
    this.loadArticle = 'oui'
    this.axios.get(this.requestHttp + 'ses_articles_en_ventes/' + this.user.id +'?page=' + this.page,{
      headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
      },
    }).then(({data}) => {
      this.articles = data[0]
      this.loadArticle = 'non'
      this.page += 1
    })
    .catch((error) => {
      console.log(error) 
    });
  },
  methods: {
    encryptId(value) {
      return this.$crypto(value); // Utilise la fonction $crypto pour chiffrer l'ID
    },
    imgLoad(image){
      event.currentTarget.src = image
    },
    addPanier(article){
      if(localStorage.getItem('jwtToken')){
        if(this.user.sexe && this.user.ville && this.user.description && this.user.date_naissance){
          this.loadAddPanier= 'non',
          this.form.id = article.id
          this.axios.post(this.requestHttp + 'add_panier', this.form,{
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
            },
          }).then(({data}) => {
            console.log(data)
            this.articlePanier.unshift(article)
            this.loadAddPanier= 'oui'
          })
          .catch((error) => {
              console.log(error) 
              this.loadAddPanier= 'erreur'
          });
        }else{
          this.$router.push('/profil');
        }
      }else{
        this.$router.push('/login');
      }
    },

    infiniteHandler(){
      this.axios.get(this.requestHttp + 'ses_articles_en_ventes/' + this.user.id +'?page=' + this.page,{
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({data}) => {
        if(data[0].data.length > 0){
          this.page += 1
          this.articles.data.push(...data[0].data)
          this.scrollExec = false 
        }else{
          this.fin = true
        }
        
      })
      .catch((error) => {
        console.log(error) 
      });
    },

    loadInfinite(e){
      const max=e.target.scrollHeight //la partie que la bar de scroll doit parcourir + la hauteur de la bar de scroll
      const base=e.target.clientHeight //la hauteur de la bar de scroll
      const scrollY=e.target.scrollTop //la distance parcouru par la bar du scroll
      const delta=max-(base+scrollY)
      if(delta <= max * 50/100 && this.scrollExec == false){
        this.scrollExec = true
        this.infiniteHandler()
      }
    },
    transformAmount(value){
      var result = ''
      if(value > 0){
        var text = Math.round(value).toString()
        var countElement = ''
        for (let i = 1; i <= text.length; i++) {
          result = text[text.length - i] + result
          countElement += text[text.length - i]
          if(countElement.length < text.length && countElement.length%3 == 0){
            result = (localStorage.getItem('langue') == 'fr' ? ',':'.') + result
          }
        }
      }else{
        result = value
      }
      
      return result
    },
  },
  computed:{
    requestHttp() {
      return this.$store.state.api
    },
    requestFile() {
      return this.$store.state.apifile
    },
  }
}
</script>

<style>
  
</style>